import Icon from '../components/Icon.vue'

Icon.register({
  'yin-yang': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM248 384C230.3 384 216 369.7 216 352S230.3 320 248 320 280 334.3 280 352 265.7 384 248 384zM248 256C195 256 152 299 152 352S195 448 248 448C142 448 56 362 56 256S142 64 248 64C301 64 344 107 344 160S301 256 248 256zM248 128C230.3 128 216 142.3 216 160S230.3 192 248 192 280 177.7 280 160 265.7 128 248 128z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/yin-yang.js
// module id = HEgf
// module chunks = 144